// PEZZ web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyC-bN1FJlwHZdL6RwseDAPRyty0PcPpzq0",
  authDomain: "pezz-3ffb7.firebaseapp.com",
  databaseURL: "https://pezz-3ffb7.firebaseio.com",
  projectId: "pezz-3ffb7",
  storageBucket: "pezz-3ffb7.appspot.com",
  messagingSenderId: "188953500869",
  appId: "1:188953500869:web:6cc702a86bc6c422df64ac"
};